import { Component, Input } from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { MessagesService }             from '../messages/messages.service';
import { VehicleVisualsService }       from './vehicle-visuals.service';
import { VehicleVisualsSettingsModel } from './typings/vehicle-visuals.settings';

@Component({
  selector   : 'wor-vehicle-visuals-settings',
  template: require('./vehicle-visuals.settings.component.html')
})
export class VehicleVisualsSettingsComponent {
  @Input() settings : VehicleVisualsSettingsModel;

  constructor (
    private messagesService      : MessagesService,
    private router               : UIRouter,
    private translateService     : TranslateService,
    private vehicleVisualsService: VehicleVisualsService
  ) {}

  disable () : void {
    this.update({
      ...this.settings,
      vehicle_visuals_api_key : null,
      vehicle_visuals_password: null,
      vehicle_visuals_user    : null
    });
  }

  save ( form : NgForm ) : void {
    if ( form.invalid ) {
      return;
    }

    this.update(this.settings);
  }

  upgrade () : void {
    this.vehicleVisualsService.subscribe()
    .catch(error => this.messagesService.error(error));
  }

  private update ( settings : VehicleVisualsSettingsModel ) : void {
    this.vehicleVisualsService.saveSettings(settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      return this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }
}
